import React, { useState, useEffect } from 'react';

// Mock images - replace with your actual imports
import img1 from '../Components/Images/antennas/concealed.png'
import img2 from '../Components/Images/antennas/concealed2.png'
function Concealedclaude() {
  const [isVisible, setIsVisible] = useState(false);
  const [activeFeature, setActiveFeature] = useState(0);

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setActiveFeature(prev => (prev + 1) % 4);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const storeTypes = [
    { icon: "fas fa-shopping-cart", name: "Supermarket" },
    { icon: "fas fa-tshirt", name: "Clothing Store" },
    { icon: "fas fa-magic", name: "Cosmetic Store" },
    { icon: "fas fa-glasses", name: "Optical Shop" },
    { icon: "fas fa-baby", name: "Infant Store" },
    { icon: "fas fa-female", name: "Boutiques" },
    { icon: "fas fa-shoe-prints", name: "Shoe Store" },
  ];

  const features = [
    {
      title: "Invisible Security, Maximum Store Aesthetics",
      description: "Concealed installation ensures a seamless, clutter-free shopping environment, enhancing store aesthetics. Improves space utilization, allowing for better store layout and customer flow.",
      icon: "fas fa-eye-slash"
    },
    {
      title: "Powerful Detection with Minimal Interference",
      description: "Self-developed mainboard provides high sensitivity and strong anti-interference, ensuring accurate detection in busy retail environments. Capable of detecting hard tags up to 2 meters for superior security coverage.",
      icon: "fas fa-bullseye"
    },
    {
      title: "Advanced Remote Debugging & Maintenance",
      description: "Remote monitoring allows for real-time tracking of system status. Remote repair capabilities reduce downtime, eliminating the need for frequent on-site service visits.",
      icon: "fas fa-tools"
    },
    {
      title: "Versatile Installation for Various Flooring Types",
      description: "Designed for easy installation under multiple floor materials, making it ideal for a wide range of retail spaces.",
      icon: "fas fa-hammer"
    }
  ];

  const specs = [
    { label: "Model No.", value: "Floor Guard Concealed System" },
    { label: "Material", value: "PVC foam board" },
    { label: "Frame Color", value: "White" },
    { label: "Frequency", value: "58Khz" },
    { label: "Hard tag", value: "1.2m-2.0m *" },
    { label: "Dimension", value: "1600*600*20MM (Customized)" },
    { label: "Operating Voltage", value: "110-220v" },
    { label: "Power Consumption", value: "100w" },
    { label: "Work Rate of Each Antenna", value: "25w" }
  ];

  return (
    <div>
      <style jsx>{`
        .modern-bg {
          background: linear-gradient(135deg, #1e293b 0%, #7c3aed 50%, #1e293b 100%);
          min-height: 100vh;
        }
        
        .hero-section {
          background: linear-gradient(rgba(59, 130, 246, 0.1), rgba(147, 51, 234, 0.1));
          padding: 80px 0;
        }
        
        .product-image-container {
          position: relative;
          transition: all 0.3s ease;
        }
        
        .product-image-container::before {
          content: '';
          position: absolute;
          top: -20px;
          left: -20px;
          right: -20px;
          bottom: -20px;
          background: linear-gradient(45deg, #06b6d4, #8b5cf6);
          border-radius: 30px;
          opacity: 0.3;
          filter: blur(20px);
          z-index: -1;
          transition: opacity 0.3s ease;
        }
        
        .product-image-container:hover::before {
          opacity: 0.5;
        }
        
        .product-image-container:hover {
          transform: scale(1.05);
        }
        
        .glass-card {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 20px;
        }
        
        .gradient-text {
          background: linear-gradient(45deg, #06b6d4, #8b5cf6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        .btn-modern {
          background: linear-gradient(45deg, #06b6d4, #8b5cf6);
          border: none;
          border-radius: 50px;
          padding: 15px 40px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }
        
        .btn-modern:hover {
          transform: translateY(-3px);
          box-shadow: 0 15px 35px rgba(139, 92, 246, 0.4);
        }
        
        .store-icon {
          width: 120px;
          height: 120px;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          transition: all 0.3s ease;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        
        .store-icon:hover {
          transform: translateY(-10px) scale(1.1);
        }
        
        .store-icon-1 { background: linear-gradient(135deg, #3b82f6, #06b6d4); }
        .store-icon-2 { background: linear-gradient(135deg, #8b5cf6, #ec4899); }
        .store-icon-3 { background: linear-gradient(135deg, #ec4899, #f43f5e); }
        .store-icon-4 { background: linear-gradient(135deg, #10b981, #14b8a6); }
        .store-icon-5 { background: linear-gradient(135deg, #f59e0b, #f97316); }
        .store-icon-6 { background: linear-gradient(135deg, #7c3aed, #8b5cf6); }
        .store-icon-7 { background: linear-gradient(135deg, #64748b, #475569); }
        
        .feature-card {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 25px;
          padding: 30px;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }
        
        .feature-card:hover {
          transform: translateY(-10px);
          background: rgba(255, 255, 255, 0.1);
          border-color: #06b6d4;
          box-shadow: 0 20px 40px rgba(6, 182, 212, 0.2);
        }
        
        .feature-card.active {
          background: rgba(255, 255, 255, 0.1);
          border-color: #06b6d4;
          box-shadow: 0 20px 40px rgba(6, 182, 212, 0.2);
        }
        
        .feature-icon {
          width: 60px;
          height: 60px;
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          margin-bottom: 20px;
          transition: all 0.3s ease;
        }
        
        .feature-icon-1 { background: linear-gradient(135deg, #3b82f6, #8b5cf6); }
        .feature-icon-2 { background: linear-gradient(135deg, #10b981, #14b8a6); }
        .feature-icon-3 { background: linear-gradient(135deg, #f59e0b, #ef4444); }
        .feature-icon-4 { background: linear-gradient(135deg, #7c3aed, #ec4899); }
        
        .specs-table {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 20px;
          overflow: hidden;
        }
        
        .specs-table th, .specs-table td {
          border: none;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          padding: 20px;
          vertical-align: middle;
        }
        
        .specs-table th {
          background: rgba(6, 182, 212, 0.2);
          color: #06b6d4;
          font-weight: 600;
        }
        
        .specs-table td {
          color: white;
        }
        
        .specs-table tr:hover {
          background: rgba(255, 255, 255, 0.05);
        }
        
        .review-card {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 25px;
          padding: 40px;
        }
        
        .user-avatar {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          background: linear-gradient(135deg, #06b6d4, #8b5cf6);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: bold;
          color: white;
          margin-bottom: 20px;
        }
        
        .fade-in-up {
          opacity: 0;
          transform: translateY(30px);
          animation: fadeInUp 0.8s ease forwards;
        }
        
        .fade-in-left {
          opacity: 0;
          transform: translateX(-50px);
          animation: fadeInLeft 0.8s ease forwards;
        }
        
        .fade-in-right {
          opacity: 0;
          transform: translateX(50px);
          animation: fadeInRight 0.8s ease forwards;
        }
        
        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeInLeft {
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes fadeInRight {
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        .floating-particles {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: -1;
        }
        
        .particle {
          position: absolute;
          width: 4px;
          height: 4px;
          background: rgba(6, 182, 212, 0.3);
          border-radius: 50%;
          animation: float 3s ease-in-out infinite;
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); opacity: 0.3; }
          50% { transform: translateY(-20px) rotate(180deg); opacity: 0.8; }
        }
      `}</style>

      {/* Floating Particles Background */}
      <div className="floating-particles">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2}s`
            }}
          />
        ))}
      </div>

      <div className="modern-bg">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="container">
            <div className="row align-items-center">
              {/* Product Image */}
              <div className={`col-lg-6 text-center mb-5 mb-lg-0 ${isVisible ? 'fade-in-left' : ''}`}>
                <div className="product-image-container">
                  <div className="glass-card p-4">
                    <img 
                      src={img1} 
                      alt="Floor Guard Concealed System" 
                      className="img-fluid rounded shadow-sm"
                      style={{width:"200px", height:"260px"}}
                    />
                  </div>
                </div>
              </div>

              {/* Product Details */}
              <div className={`col-lg-6 ${isVisible ? 'fade-in-right' : ''}`}>
                <div className="mb-4">
                  <span className="badge bg-primary px-4 py-2 rounded-pill fs-6">
                    Premium Security Solution
                  </span>
                </div>
                
                <h1 className="display-5 fw-bold text-white mb-4">
                  Argus AM<br/>Floor Systems
                  {/* <span className="gradient-text">Concealed Systems</span> */}
                </h1>

                <p className="fs-5 text-light mb-4 opacity-75">
                  Do you want unobscured access to your store, maintaining maximized visitor flow combined with solid merchandise protection? Our ARGUS AM Floor System offers ultimate discretion while performing its highly advanced security task.
                </p>

                <p className="text-light mb-5 opacity-75">
                  The basic ARGUS AM Floor System consists of a wall mount control unit and an external antenna (2 transceiver coils), which is completely integrated in the floor of the store's entrance.
                </p>

                <button className="btn btn-modern btn-lg text-white">
                  Get a Quote
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Store Types */}
        <section className="py-5">
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="display-5 fw-bold text-white mb-4">
                Perfect for <span className="gradient-text">Every Retail Space</span>
              </h2>
            </div>
            
            <div className="row justify-content-center">
              {storeTypes.map((store, index) => (
                <div key={index} className={`col-6 col-md-4 col-lg-3 col-xl mb-4 fade-in-up`} style={{animationDelay: `${index * 0.1}s`}}>
                  <div className={`store-icon store-icon-${index + 1} mx-auto`}>
                    <i className={`${store.icon} fa-2x text-white mb-2`}></i>
                    <small className="text-white fw-semibold text-center">{store.name}</small>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-5">
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="display-6 fw-bold text-white mb-4">
                What's more in Argum AM 
                <span className="d-block gradient-text">concealed systems?</span>
              </h2>
            </div>

            <div className="row">
                {features.map((feature, index) => (
                    <div key={index} className="col-lg-6 mb-4">
                    <div className={`feature-card h-100 d-flex flex-column align-items-center text-center p-3 ${activeFeature === index ? 'active' : ''}`}>
                        <div className={`feature-icon feature-icon-${index + 1} mb-3`}>
                        <i className={`${feature.icon} text-white fs-2`}></i>
                        </div>
                        
                        <h3 className="h6 fw-bold text-white mb-2">
                        {feature.title}
                        </h3>
                        
                        <p className="text-light opacity-75 mb-0">
                        {feature.description}
                        </p>
                    </div>
                    </div>
                ))}
                </div>

          </div>
        </section>

        {/* Technical Specifications */}
        <section className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="text-center mb-5">
                  <h2 className="display-4 fw-bold text-white mb-4">
                    Technical <span className="gradient-text">Specifications</span>
                  </h2>
                </div>

                <div className="specs-table">
                  <table className="table table-hover mb-0">
                    <tbody>
                      {specs.map((spec, index) => (
                        <tr key={index}>
                          <th className="w-50">{spec.label}</th>
                          <td>{spec.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="text-center mt-5">
                  <div className="product-image-container d-inline-block">
                    <div className=" p-2">
                      <img 
                        src={img2} 
                        alt="Technical Diagram" 
                        className="img-fluid rounded w-75"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Customer Reviews */}
        <section className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="text-center mb-5">
                  <h2 className="display-4 fw-bold text-white mb-4">
                    Product <span className="gradient-text">Reviews</span>
                  </h2>
                </div>

                <div className="review-card text-center">
                  <div className="user-avatar mx-auto">
                    JD
                  </div>
                  
                  <h3 className="h4 fw-bold text-white mb-3">John Doe</h3>
                  
                  <div className="mb-4">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="fas fa-star text-warning fs-4 me-1"></i>
                    ))}
                  </div>
                  
                  <blockquote className="fs-5 text-light opacity-75 fst-italic">
                    "Great security system! It helped reduce shoplifting incidents by 80% in our store. The concealed design is absolutely perfect - customers don't even notice it's there."
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Concealedclaude;